export function useCurrency() {
  const currency = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return currency
}
